import { map } from "guinho-automapper-js/index";
import createMapping  from "../../../../mappers/questionnaire/field/option/list/jsonapi-option-list-map";

const convertToViewModel = (data) => {

  const viewModel = map(data, {}, createMapping(data.data.length));

  return viewModel;
};

export { convertToViewModel };